module.exports = __webpack_public_path__ + "static/img/case2.683f52d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/20250903/ldt/case2.png
// module id = ACS7
// module chunks = 0